import * as Sentry from '@sentry/react'
import { createRouter } from '@tanstack/react-router'

import '@/integrations/external-api'
import '@/integrations/i18n-countries'

import reportWebVitals from './reportWebVitals'
import { routeTree } from './routeTree.gen'

import { env } from '@/lib/env'

export const router = createRouter({
  routeTree,
  // context: {
  //   ...TanStackQueryProviderContext,
  // },
  defaultPreload: 'intent',
  scrollRestoration: true,
  defaultStructuralSharing: true,
  defaultPreloadStaleTime: 0,
})

// Initialize Sentry only if not already initialized
// This prevents the "Multiple Sentry Session Replay instances" error
if (!Sentry.getClient()) {
  Sentry.init({
    dsn: env.VITE_SENTRY_DSN,
    environment: env.VITE_SENTRY_ENV,
    release: env.VITE_SENTRY_RELEASE,
    sendDefaultPii: true,

    // Add these for better frontend error catching
    integrations: [
      Sentry.tanstackRouterBrowserTracingIntegration(router),
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],

    // Catch more errors
    tracesSampleRate: 1.0,
    // Prod: 0 — only record sessions where an error fires (replaysOnErrorSampleRate
    // captures those). Dev: 0.1 so you can verify replay works without forcing an error.
    replaysSessionSampleRate: env.VITE_SENTRY_ENV === 'production' ? 0 : 0.1,
    replaysOnErrorSampleRate: 1.0,

    tracePropagationTargets: ['localhost', /^https:\/\/groute\.io\/api/],

    // Drop noise that's never actionable: ResizeObserver loop warnings (harmless,
    // browser-emitted) and "Non-Error promise rejection" wrappers around primitives.
    ignoreErrors: [
      /^ResizeObserver loop/,
      'Non-Error promise rejection captured',
    ],
    // Errors thrown from inside browser extensions are not our code.
    denyUrls: [
      /^chrome-extension:\/\//,
      /^moz-extension:\/\//,
      /^safari-extension:\/\//,
      /^safari-web-extension:\/\//,
    ],
  })
}

export function getRouter() {
  return router
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
